import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, inr, today } from "@/lib/api";
import { TableWrap, th, td, tr } from "@/components/common";

const COLS = [["opening", "Opening"], ["total_in", "Total In (+)"], ["total_out", "Total Out (−)"], ["contra_in", "Contra In (+)"], ["contra_out", "Contra Out (−)"]];

function Row({ r, total }) {
  return (
    <tr className={`${tr} ${total ? "font-bold" : ""}`} data-testid={`report-row-${total ? "total" : r.bank_key}`}>
      <td className={td}>{total ? "TOTAL" : r.bank_name}{!total && <div className="font-mono text-[10px] text-muted-foreground">{r.account_number || "A/c [not set]"}</div>}</td>
      {COLS.map(([k]) => <td key={k} className={`${td} amount ${k === "total_in" ? "text-emerald-600" : k === "total_out" ? "text-rose-600" : ""}`}>{inr(r[k], 2)}</td>)}
      <td className={`${td} text-xs`}><b className="text-amber-600">{r.suspense_count}</b> · +{inr(r.suspense_in)} / −{inr(r.suspense_out)}</td>
      <td className={`${td} amount font-semibold`} data-testid={`report-closing-${total ? "total" : r.bank_key}`}>{inr(r.closing, 2)}</td>
      <td className={`${td} amount text-muted-foreground`}>{inr(r.closing_incl_suspense, 2)}</td>
    </tr>
  );
}

export function ReportTab() {
  const [month, setMonth] = useState(today().slice(0, 7));
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    if (month) api.get("/bank/report", { params: { month } }).then((r) => { if (live) setD(r.data); }).catch((e) => toast.error(errMsg(e)));
    return () => { live = false; };
  }, [month]);
  const pdf = async () => {
    setBusy(true);
    try {
      const r = await api.get("/bank/report/pdf", { params: { month }, responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `Bank_Reconciliation_${month}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div>
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <Input type="month" className="w-44" data-testid="report-month" value={month} onChange={(e) => setMonth(e.target.value)} />
        <Button size="sm" data-testid="report-pdf-btn" disabled={!d || busy} onClick={pdf}><FileDown className="mr-1 h-4 w-4" />Download PDF</Button>
      </div>
      {d && <TableWrap>
        <thead><tr>{["Bank", ...COLS.map((c) => c[1]), "Suspense Left", "Closing Balance", "Closing incl. Suspense"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
        <tbody>{d.rows.map((r) => <Row key={r.bank_key} r={r} />)}<Row r={d.totals} total /></tbody>
      </TableWrap>}
      <p className="mt-2 text-xs text-muted-foreground">Opening = opening balance + pichhle reconciled entries (effective date se). Closing = Opening + In − Out + Contra In − Contra Out. Contra = apne hi do bank ke beech transfer (income / kharcha nahi). Suspense entries closing me shamil nahi hain.</p>
    </div>
  );
}
